import React from "react";
import "./Button.css";

interface ButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  color?: string; // Optional color prop
}

const Button: React.FC<ButtonProps> = ({ text, onClick, className, color }) => {
  const backgroundColor = color || "#FDB73E";
  const textColor = backgroundColor === "#FDB73E" ? "#000" : undefined;

  return (
    <div className="podcast-bottom-btn-wrapper">
      <button
        className={`podcast-bottom-btn${className ? ` ${className}` : ""}`}
        onClick={onClick}
        style={{
          backgroundColor,
          color: textColor,
        }}
      >
        {text}
      </button>
    </div>
  );
};

export default Button;
